import { gql } from '@apollo/client';

export const DATA_WAREHOUSE_EXPORT_CREATE = gql`
    mutation CreateDataWarehouseExport($input: CreateDataWarehouseExportInput!) {
        createDataWarehouseExport(input: $input) {
            id
            exportTypeId
            s3Key
            format
            status
            metadata
            startedAt
            completedAt
            createdAt
            updatedAt
            url
        }
    }
`;

export default DATA_WAREHOUSE_EXPORT_CREATE;
